import useApi from '../hook/useApi';

const useSalesHistoryApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const getStates = async (filter) => {
    const queryParams = new URLSearchParams();
    if (filter) queryParams.append('filter', filter.filter);
    if (filter.start_date) queryParams.append('start_date', filter.start_date);
    if (filter.end_date) queryParams.append('end_date', filter.end_date);
    return sendRequest(`/imp/sales_screen/get_calculatedinfo?${queryParams.toString()}`, 'GET', {});
  };

  const getSalesData = async (page = 1,search="") => {
    return sendRequest(`/imp/sales_screen/get_all_sales?page=${page}&search=${search}`, 'GET', {});
  };


  // const approveRejectWithdrwal = async (id, payload) => {
  //   return sendRequest(`/imp/widrowlScreen/editRequest/${id}`, 'POST', payload);
  // };

  return {
    getStates,
    getSalesData,
    loading,
    data,
    error,
  };
};

export default useSalesHistoryApi;